export default __webpack_public_path__ + "static/change-status-4fa7fbabd04157c788906a8cb662caf6.gif";